import { render } from "./NewDistributor.vue?vue&type=template&id=5c4c2dfa&scoped=true"
import script from "./NewDistributor.vue?vue&type=script&lang=js"
export * from "./NewDistributor.vue?vue&type=script&lang=js"

import "./NewDistributor.vue?vue&type=style&index=0&id=5c4c2dfa&scoped=true&lang=css"

import exportComponent from "/home/accesa/Documents/ACCESA/DANA_PROJECTS/DANA-LITE/dana-lite-registro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4c2dfa"]])

export default __exports__